<template>
    <vue-modal
        v-model="voucher.isVisibleModal"
        v-if="voucher.isVisibleModal"
        :header="false"
        :footer="false"
        :modalBodyClass="$prefixClass.modal + '-voucher'"
    >
        <div class="charge-voucher text-center m-b-8 m-t-20">
            <p class="m-b-0">{{$t('pricing.voucher.package')}}</p>
            <h3 class="m-b-8">${{voucher.data.price}}</h3>
            <p>{{$t('pricing.voucher.current_discount')}}: <strong>{{voucher.discount | filterDiscountType({type: voucher.discountType})}}.</strong> 
            {{$t('pricing.voucher.total_payment')}}: <strong>${{voucher.data.price | filterTotalPayment({type: voucher.discountType, discount: voucher.discount})}}/{{$t('pricing.voucher.month')}}</strong></p>
            <div class="charge-voucher__input-group m-t-24">
                <div :class="['d-flex justify-content-center', $prefixClass.row, $prefixClass.form + '-item', voucher.formstate && $v.voucher.code.$invalid ? 'has-rrror' : '']">
                    <label :class="[$prefixClass.label, $prefixClass.col + '-8']">{{$t('pricing.voucher.your_discount_code')}}:</label>
                    <div :class="[$prefixClass.col + '-12', voucher.formstate && (!$v.voucher.code.required || !$v.voucher.code.valid) ? 'has-error': '']">
                        <a-input :placeholder="$t('pricing.voucher.input_your_code')" v-model="voucher.code" @change="onEnterCodeDiscount"/>
                        <transition name="fade-in" mode="out-in">
                            <div v-if="voucher.formstate && !$v.voucher.code.required" class="form-error">
                                {{ $t('errors.required_field') }}
                            </div>
                            <div  v-else-if="voucher.formstate && !$v.voucher.code.valid" class="form-error">
                                {{ voucher.msgError }}
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
            <a-button type="primary" class="m-t-8" @click="acceptVoucher" :disabled="voucher.disbaledAcctep">{{$t('pricing.voucher.accept')}}</a-button>
        </div>
    </vue-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
import { types as typesCharge } from './../constant'
export default {
    name: 'Voucher',
    props:{
        data: Object,
        resetOnVoucher: Number,
        resetOnChargePlan: Number
    },
    validations: () => ({
        voucher: {
            code :{
                required,
                valid : function(value){
                    return this.voucher.isError
                }
            }
        },
    }),
    data(){
        return{
            voucher: {
                data: null,
                discount: 0,
                isVisibleModal: false,
                disbaledAcctep: true,
                timer: null,
                isError: false,
                msgError: '',
                code: '',
                discountType: 'percent',
                formstate: false
            }
        }
    },
    watch:{
        resetOnVoucher(){
            this.onVoucher()
        },
        resetOnChargePlan(){
            this.onChargePlan({name: this.data.name, discountCode: this.data.discountCode, usedTrial: this.data.usedTrial})
        }
    },
    filters: {
        filterDiscountType: function (value, {type}) {
            if(!value){
                return `${0}%`
            }
            if(type == 'amount'){
                return `$${value}`
            }
            return `${value}%`
        },
        filterTotalPayment: function (value, {type, discount}) {
            let result = value
            if(!discount){
                return result
            }
            if(type == 'amount'){
                result = value - discount
                if(value - discount < 0){
                    return 0
                }
                result = result.toFixed(2)
                return result
            }
            result = value - (value/100 * discount)
            result = result.toFixed(2)
            return result
        }
    },
    methods:{
        ...mapActions({
            checkDiscount: typesCharge.actions.CHECK_DISCOUNT,
            handleChargePlan: typesCharge.actions.HANDLE_CHARGE_PLAN
        }),
        onVoucher(){
            this.voucher.discount = '';
            this.voucher.disbaledAcctep = true
            this.voucher.data = this.data.plan
            this.voucher.isError = false
            this.voucher.msgError = ''
            this.voucher.formstate = false
            this.voucher.code = ''
            this.voucher.isVisibleModal = this.data.isVisibleModal
        },
        acceptVoucher(){
            this.onChargePlan({name: this.voucher.data.name, discountCode: this.voucher.code, usedTrial: this.voucher.usedTrial})
        },
        onChargePlan({name, discountCode = '', usedTrial = false }){
            this.voucher.disbaledAcctep = true
            this.handleChargePlan({plan: name, discount_code: discountCode, used_trial: usedTrial }).then( res => {
                let { status, data } = res.data
				if(status){
					window.location.href = data.redirect_url
                }
                this.voucher.disbaledAcctep = false
			})
        },
        onEnterCodeDiscount($event){
            clearTimeout(this.voucher.timer)
            let target = $event.target
            if(!target.value){
                return false
            }
            this.voucher.timer = setTimeout(() => {
                this.checkDiscount({plan: this.voucher.data.name, code: target.value}).then(res => {
                    let { status, data, message } = res.data
                    if(status){
                        this.voucher.disbaledAcctep = false
                        this.voucher.isError = true
                        this.voucher.msgError = ''
                        this.voucher.discount = data.discount && data.discount.discount
                        this.voucher.discountType = data.discount && data.discount.discount_type
                    }else{
                        this.voucher.isError = false
                        this.voucher.disbaledAcctep = true
                        this.voucher.msgError = message
                        this.voucher.discount = 0
                        this.voucher.discountType = 'percent'
                    }
                    this.voucher.formstate = true
                })
            }, 500)
        }
    }
}
</script>